import { render, staticRenderFns } from "./formsRelease.vue?vue&type=template&id=6f426ae5"
import script from "./formsRelease.vue?vue&type=script&lang=js"
export * from "./formsRelease.vue?vue&type=script&lang=js"
import style0 from "./formsRelease.vue?vue&type=style&index=0&id=6f426ae5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports